/* Small helpers for authenticated file downloads from Command Center.
 * Uses axios blob → object URL → click a hidden anchor so the browser
 * treats it as a normal download while still sending the Bearer token. */
import { api } from "@/lib/api";
import { toast } from "sonner";

async function downloadBlob(url, fallbackFilename) {
  const { data, headers } = await api.get(url, { responseType: "blob" });
  // Prefer the filename Content-Disposition gives us; fall back if missing.
  let filename = fallbackFilename;
  const cd = headers["content-disposition"] || headers["Content-Disposition"];
  const m = cd && cd.match(/filename="?([^"]+)"?/);
  if (m) filename = m[1];
  const blobUrl = URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

export async function downloadCsv(kind, extra = {}) {
  const paths = {
    "lead-sources": "/command-center/lead-sources/export.csv",
    "expenses":     "/command-center/expenses/export.csv",
    "monthly":      `/command-center/monthly/export.csv?year=${extra.year}`,
  };
  const filenames = {
    "lead-sources": "iSpeedToClose_LeadPlanner.csv",
    "expenses":     "iSpeedToClose_Expenses.csv",
    "monthly":      `iSpeedToClose_MonthlyTracker_${extra.year}.csv`,
  };
  try {
    await downloadBlob(paths[kind], filenames[kind]);
    toast.success("Download started.");
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Download failed.");
  }
}

export async function downloadAnnualReport(year) {
  try {
    await downloadBlob(
      `/command-center/report.pdf?year=${year}`,
      `iSpeedToClose_BusinessReport_${year}.pdf`,
    );
    toast.success("Annual report downloaded.");
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Could not generate report.");
  }
}
